/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MassDownloadRequestDto
 */
export interface MassDownloadRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof MassDownloadRequestDto
     */
    idsfichier?: Array<number> | null;
}

/**
 * Check if a given object implements the MassDownloadRequestDto interface.
 */
export function instanceOfMassDownloadRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MassDownloadRequestDtoFromJSON(json: any): MassDownloadRequestDto {
    return MassDownloadRequestDtoFromJSONTyped(json, false);
}

export function MassDownloadRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MassDownloadRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsfichier': !exists(json, 'idsfichier') ? undefined : json['idsfichier'],
    };
}

export function MassDownloadRequestDtoToJSON(value?: MassDownloadRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsfichier': value.idsfichier,
    };
}

